export class City {
    public cityName:string;

    public cityId:string;

    public carryStations:CarryStation[]

    constructor(){
    }

  
}

export class CarryStation{
    public carryStationName:string;
    public  carryStationId:string;

    public preSaleDay:number;
}


// WEBPACK FOOTER //
// ./src/models/City.ts